import { EstoqueRepository } from "../repository/estoque_repository";

export class EstoqueService {
	constructor() {
		this.estoqueRepository = new EstoqueRepository();
	}

	async getEstoque(unidadeDistribuidoraId, search) {
		return await this.estoqueRepository.getEstoque(unidadeDistribuidoraId, search);
	}

	async getEstoqueEntradas(unidadeDistribuidoraId, search) {
		return await this.estoqueRepository.getEstoqueEntradas(unidadeDistribuidoraId, search);
	}
}
